import { PLAYER_REPORT_REASONS, REPORT_DETAILS_MAX, type ReportReason } from '@shefira/shared';

import './party.css';
import './admin.css';

import { closeButton } from './hud.js';
import { REPORT_REASON_LABELS } from './moderation-text.js';
import { uiFormat, uiText } from './text.js';
import { kitTitle } from './kit.js';

/**
 * « Signaler <Nom> » (ADR 0037): a reason among the server's list and a few
 * words of detail, sent as a `report` intent. The same stone frame as an
 * invitation; the cross or Escape drops it without sending.
 */
export class ReportPrompt {
  private root?: HTMLElement;
  private readonly onKey = (event: KeyboardEvent): void => {
    if (event.key === 'Escape') this.close();
  };

  open(name: string, onSend: (reason: ReportReason, details: string) => void): void {
    this.close();
    const root = document.createElement('div');
    root.className = 'party-invite report';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-label', uiFormat('Signaler {name}', { name }));

    const title = document.createElement('p');
    title.className = 'report__title';
    kitTitle(title, 'report');
    title.textContent = uiFormat('Signaler {name}', { name });

    const reason = document.createElement('select');
    reason.className = 'gm__select report__reason';
    reason.setAttribute('aria-label', uiText('Motif'));
    for (const value of PLAYER_REPORT_REASONS) {
      const option = document.createElement('option');
      option.value = value;
      option.textContent = uiText(REPORT_REASON_LABELS[value]);
      reason.append(option);
    }

    const details = document.createElement('textarea');
    details.className = 'report__details';
    details.maxLength = REPORT_DETAILS_MAX;
    details.rows = 3;
    details.placeholder = uiText('Ce qui s’est passé (facultatif)');
    details.setAttribute('aria-label', uiText('Détails'));

    const actions = document.createElement('div');
    actions.className = 'party-invite__actions';
    const send = document.createElement('button');
    send.type = 'button';
    send.className = 'party-invite__button';
    send.textContent = uiText('Envoyer');
    send.addEventListener('click', () => {
      const chosen = PLAYER_REPORT_REASONS.find((value) => value === reason.value) ?? 'autre';
      const text = details.value.trim();
      this.close();
      onSend(chosen, text);
    });
    actions.append(send);

    // Typing a detail must not walk, mount or open another window.
    root.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') event.stopPropagation();
    });

    root.append(
      closeButton('Annuler (Échap)', () => {
        this.close();
      }),
      title,
      reason,
      details,
      actions,
    );
    document.body.append(root);
    this.root = root;
    window.addEventListener('keydown', this.onKey);
    details.focus();
  }

  close(): void {
    window.removeEventListener('keydown', this.onKey);
    this.root?.remove();
    this.root = undefined;
  }
}
